import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, DSID, eventBus, OrganizationAccessUpdated, PmStore } from "@/state";



const queryMe = gql`
  query me { 
    me { 
        id
        first_name
        last_name
        phone_number
    }
 }
`;



const queryGetMyEmailAddresses = gql`
  query myEmailAddresses { 
    myEmailAddresses { 
        account_id
        email_address
    }
 }
`;


const mutationSetFirstName = gql`
   mutation setFirstName( $firstName: String   ) {
      setFirstName(firstName: $firstName ) 
    }
  `;




  const mutationSetLastName = gql`
   mutation setLastName( $lastName: String   ) {
      setLastName(lastName: $lastName ) 
    }
  `;



const mutationSetPhoneNumber = gql`
   mutation setPhoneNumber( $phoneNumber: String   ) {
      setPhoneNumber(phoneNumber: $phoneNumber ) 
    }
`;



const queryGetAccount = gql`
  query getAccount($accountId: UUID!) {
    account(id: $accountId) {
      id
      first_name
      last_name
      phone_number
      
    }
    accountEmailAddresses(id: $accountId) {
        email_address
    }
  }
`;





const mutationRevokeUserOrgAppAccess = gql`
   mutation revokeUserOrganizationApplicationAccess( $applicationId: UUID!, $organizationId: UUID! , $accountId: UUID!, $roleId: UUID! ) {
      revokeUserOrganizationApplicationAccess(applicationId: $applicationId, organizationId: $organizationId,accountId: $accountId, roleId: $roleId ) 
    }
`;


const queryIamApplicationAccounts = gql`
  query ApplicationAccounts($organizationId: UUID!, $applicationId: UUID!) {
     applicationAccounts(organizationId: $organizationId, applicationId: $applicationId) {
         account_id
         account {
             first_name
             last_name
             phone_number
             id
         }
         role_id
         role {
             id
             name
         }
         
     }
   }
`;
 

const queryGetApplicationRoles = gql`
  query applicationRoles($applicationId: UUID!) {
    applicationRoles(applicationId: $applicationId) {
      id
      name
      permissions {
        key 
        value
      }
    }
  }
`;



const mutationGrantUserOrganizationApplicationAccess = gql`
  mutation GrantUserOrganizationApplicationAccess(
    $applicationId: UUID!, 
    $organizationId: UUID!
    $emailAddress: String!,
    $firstName: String!,
    $lastName: String!,
    $roleId: UUID!
    ) {
    grantUserOrganizationApplicationAccess(
        applicationId: $applicationId, 
        organizationId: $organizationId
        emailAddress: $emailAddress,
        firstName: $firstName,
        lastName: $lastName,
        roleId: $roleId,
        ) 
        
  }
`;


const queryGetMyRoles = gql`
query myRoles($applicationId: UUID, $organizationId: UUID) {
  myRoles(applicationId: $applicationId, organizationId: $organizationId) {
    id
    name
    permissions {
      key 
      value
    }
  }
}
`;



const queryLogin = gql`
mutation login($email: String!, $password: String!) {
  login(emailAddress: $email, password: $password, appId: "d372cf0a-d449-4f73-92d4-9a279d35caf1")
}
`;



export function useIamActions() {
    const state = PmStore();
    const [apiGetMe] = useLazyQuery(queryMe,{ fetchPolicy: "network-only"});
    const [apiGetMyEmailAddresses] = useLazyQuery(queryGetMyEmailAddresses);
    const [apiSetFirstName] = useMutation(mutationSetFirstName);
    const [apiSetLastName] = useMutation(mutationSetLastName);
    const [apiSetPhoneNumber] = useMutation(mutationSetPhoneNumber);
    const [apiGetAccount] = useLazyQuery(queryGetAccount);
    const [apiRevokeUserOrgAppAccess] = useMutation(mutationRevokeUserOrgAppAccess);
    const [apiGetOrganizationAccess] = useLazyQuery(queryIamApplicationAccounts);
    const [apiGetApplicationRoles] = useLazyQuery(queryGetApplicationRoles);
    const [apiGrantUserOrgAppAccess] = useMutation(mutationGrantUserOrganizationApplicationAccess);
    const [apiGetMyRoles] = useLazyQuery(queryGetMyRoles);
    const [apiLogin] = useMutation(queryLogin);
    


    async function Login(email: string, password: string) {
        try {
            let result = await apiLogin({ variables:  {email, password}}) as any;
            return result.data.login as any;
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await Login( email, password);
            }
            else {
                toast.error("Api Error, Unable to log in");
                throw error;
            }
        }
    }
    




    async function GetMyRoles(organizationId: string) {
        try {
            let result = await apiGetMyRoles({ variables:  {organizationId, applicationId: DSID}}) as any;
            return result.data.myRoles ?? [];
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await GetMyRoles(organizationId);
            }
            else {
                toast.error("Api Error, Unable to get my roles");
                throw error;
            }
        }
    }

   



    function GrantUserOrgAppAccess(organizationId: string, emailAddress: string, firstName: string, lastName: string, roleId: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiGrantUserOrgAppAccess({ variables: { 
                    applicationId: DSID,
                    organizationId,
                    emailAddress,
                    firstName,
                    lastName,
                    roleId
                 } })
                .then((result: any) => result?.data?.grantUserOrganizationApplicationAccess)
                .then((result) => resolve(result))
                .then(() => eventBus.next({type:OrganizationAccessUpdated}))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to grant account access.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }





    function GetApplicationRoles() {
        return new Promise(async (resolve, reject) => {
            try {
                apiGetApplicationRoles({ variables: { 
                     applicationId: DSID
                 } })
                .then((result: any) => result?.data?.applicationRoles)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to get roles.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }



    function GetOrganizationAccess(organizationId: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiGetOrganizationAccess({ variables: { 
                    organizationId,
                     applicationId: DSID
                 } })
                .then((result: any) => result?.data?.applicationAccounts)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to get access.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }


    function RevokePmAccountAccess(organizationId: string, accountId: string, roleId: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiRevokeUserOrgAppAccess({ variables: { 
                    applicationId: DSID,
                    organizationId,
                    accountId,
                    roleId
                 } })
                .then((result: any) => result?.data?.revokeUserOrganizationApplicationAccess)
                .then((result) => resolve(result))
                .then(() => eventBus.next({type:OrganizationAccessUpdated}))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to revoke account access.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }


    function GetAccount(accountId: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiGetAccount({ variables: { accountId } })
                .then((result: any) => result?.data)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to get account.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }

    function SetPhoneNumber(phoneNumber: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiSetPhoneNumber({ variables: { phoneNumber } })
                .then((result: any) => result?.data?.setPhoneNumber)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to set phone number.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }

    function SetLastName(lastName: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiSetLastName({ variables: { lastName } })
                .then((result: any) => result?.data?.setLastName)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, unable to set last name.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }

    function SetFirstName(firstName: string) {
        return new Promise(async (resolve, reject) => {
            try {
                apiSetFirstName({ variables: { firstName } })
                .then((result: any) => result?.data?.setFirstName)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, Unable to set first name.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }

    function GetMyEmailAddresses() {
        return new Promise(async (resolve, reject) => {

            try {
                apiGetMyEmailAddresses()
                .then((result: any) => result?.data?.myEmailAddresses)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, Unable to get your account.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }
    
    function GetMe() {
        return new Promise(async (resolve, reject) => {

            try {
                apiGetMe()
                .then((result: any) => result?.data?.me)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }
                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                    }
                    toast.error("Api Error, Unable to get your account.");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }
        })
    }
    
    return {
        GetMe,
        GetMyEmailAddresses,
        SetFirstName,
        SetLastName,
        SetPhoneNumber,
        GetAccount,
        RevokePmAccountAccess,
        GetOrganizationAccess,
        GetApplicationRoles,
        GrantUserOrgAppAccess,
        GetMyRoles,
        Login
    };
}